import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'
import SettingsAccountProfile from './SettingsAccountProfile'
import SettingsAccountPassword from './SettingsAccountPassword'
import SettingsAccountAutomation from './SettingsAccountAutomation'
import SettingsAccountDelete from './SettingsAccountDelete'
import SettingsBillingSubscription from './SettingsBillingSubscription'
import SettingsImport from './SettingsImport'
import SettingsSupport from './SettingsSupport'
import SettingsExport from './SettingsExport'

const TabPanel = memo(props => {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </div>
  )
})

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

const useStyles = makeStyles(theme => ({
  tabPanel: {
    width: 600,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default memo(props => {
  const classes = useStyles()
  return (
    <div>
      <TabPanel value={props.value} index={0} className={classes.tabPanel}>
        <SettingsBillingSubscription styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={1} className={classes.tabPanel}>
        <SettingsAccountProfile styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={2} className={classes.tabPanel}>
        <SettingsAccountPassword styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={3} className={classes.tabPanel}>
        <SettingsAccountAutomation styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={4} className={classes.tabPanel}>
        <SettingsAccountDelete styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={5} className={classes.tabPanel}>
        <SettingsImport styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={6} className={classes.tabPanel}>
        <SettingsExport styles={classes} {...props} />
      </TabPanel>
      <TabPanel value={props.value} index={7} className={classes.tabPanel}>
        <SettingsSupport styles={classes} {...props} />
      </TabPanel>
    </div>
  )
})
